export default __webpack_public_path__ + "static/media/productDiscountAfterThreshold.a670c3ad.webp";